import { ReduxAction } from '../../types/common'
import { SET_ERRORS, GET_USERS, UPDATE_USER_TERRITORY } from '../actionTypes'

export interface User {
  id: number | null
  firstName: string | null
  lastName: string | null
  clientId: number | null
}

interface UserState {
  users: User[]
  user: User | null
}

const INITIAL_STATE = {
  users: [],
  user: null
}

export const users = (state: UserState = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload,
      }
    case UPDATE_USER_TERRITORY:
      return {
        ...state,
        user: action.payload,
      }
    case SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      }
    default:
      return state
  }
}
